/**
 * Ok the whole idea about this is to do it "dynamically". How?
 * we have the remote channel as value from the integraction of the channels.
 * They send us a parameter called "paymentChannel" with 3 posibility of values and we put in the indexes of the object.
 * With thus we took the value and we can get all the interaccions for every step in the app.
 * At the bottom you can uncomment the logs and see what it shows
 */
const interactions = {
    "vtr_com": {
        "billing": "1755",
        "pt": {
            "payment": "1748",
            "webpay": {
                "method": "1750",
                "ok": "1754",
                "er": "1752"
            },
            "servipag": {
                "method": "1749",
                "ok": "1753",
                "er": "1751"
            }
        },
        "hven": {
            "payment": "1756",
            "webpay": {
                "method": "1759",
                "ok": "1767",
                "er": "1763"
            },
            "servipag": {
                "method": "1758",
                "ok": "1766",
                "er": "1762"
            }
        },
        "hvig": {
            "payment": "1757",
            "webpay": {
                "method": "1761",
                "ok": "1769",
                "er": "1765"
            },
            "servipag": {
                "method": "1760",
                "ok": "1768",
                "er": "1764"
            }
        },
        "mven": {
            "payment": "1770",
            "webpay": {
                "method": "1773",
                "ok": "1781",
                "er": "1777"
            },
            "servipag": {
                "method": "1772",
                "ok": "1780",
                "er": "1776"
            }
        },
        "mvig": {
            "payment": "1771",
            "webpay": {
                "method": "1775",
                "ok": "1783",
                "er": "1779"
            },
            "servipag": {
                "method": "1774",
                "ok": "1782",
                "er": "1778"
            }
        },
        "sendInvoiceEmail": {
            "ok":"1903",
            "er":"1905"
        },
        "initial":"1949",
        "modalHbo": "3",

    },
    "sucursal_virtual": {
        "billing": "1719",
        "pt": {
            "payment": "1712",
            "webpay": {
                "method": "1714",
                "ok": "1718",
                "er": "1716"
            },
            "servipag": {
                "method": "1713",
                "ok": "1717",
                "er": "1715"
            }
        },
        "hven": {
            "payment": "1720",
            "webpay": {
                "method": "1723",
                "ok": "1731",
                "er": "1727"
            },
            "servipag": {
                "method": "1722",
                "ok": "1730",
                "er": "1726"
            }
        },
        "hvig": {
            "payment": "1721",
            "webpay": {
                "method": "1725",
                "ok": "1733",
                "er": "1729"
            },
            "servipag": {
                "method": "1724",
                "ok": "1732",
                "er": "1728"
            }
        },
        "mven": {
            "payment": "1734",
            "webpay": {
                "method": "1737",
                "ok": "1745",
                "er": "1741"
            },
            "servipag": {
                "method": "1736",
                "ok": "1744",
                "er": "1740"
            }
        },
        "mvig": {
            "payment": "1735",
            "webpay": {
                "method": "1739",
                "ok": "1747",
                "er": "1743"
            },
            "servipag": {
                "method": "1738",
                "ok": "1746",
                "er": "1742"
            }
        },
        "sendInvoiceEmail": {
            "ok":"1900",
            "er":"1901"
        }
    },
    "apps": {
        "billing": "1791",
        "pt": {
            "payment": "1784",
            "webpay": {
                "method": "1786",
                "ok": "1790",
                "er": "1788"
            },
            "servipag": {
                "method": "1785",
                "ok": "1789",
                "er": "1787"
            }
        },
        "hven": {
            "payment": "1792",
            "webpay": {
                "method": "1795",
                "ok": "1803",
                "er": "1799"
            },
            "servipag": {
                "method": "1794",
                "ok": "1802",
                "er": "1798"
            }
        },
        "hvig": {
            "payment": "1793",
            "webpay": {
                "method": "1797",
                "ok": "1805",
                "er": "1801"
            },
            "servipag": {
                "method": "1796",
                "ok": "1804",
                "er": "1800"
            }
        },
        "mven": {
            "payment": "1806",
            "webpay": {
                "method": "1809",
                "ok": "1817",
                "er": "1813"
            },
            "servipag": {
                "method": "1808",
                "ok": "1816",
                "er": "1812"
            }
        },
        "mvig": {
            "payment": "1807",
            "webpay": {
                "method": "1811",
                "ok": "1819",
                "er": "1815"
            },
            "servipag": {
                "method": "1810",
                "ok": "1818",
                "er": "1814"
            }
        },
        "sendInvoiceEmail": {
            "ok":"1902",
            "er":"1904"
        }
    },
    "baf": {
        "billing": "1934",
        "pt": {
            "payment": "1935",
            "webpay": {
                "method": "1937",
                "ok": "1941",
                "er": "1939"
            },
            "servipag": {
                "method": "1936",
                "ok": "1940",
                "er": "1938"
            }
        },
        "hven": {
            "payment": "1906",
            "webpay": {
                "method": "1909",
                "ok": "1917",
                "er": "1913"
            },
            "servipag": {
                "method": "1908",
                "ok": "1916",
                "er": "1912"
            }
        },
        "hvig": {
            "payment": "1907",
            "webpay": {
                "method": "1911",
                "ok": "1919",
                "er": "1915"
            },
            "servipag": {
                "method": "1910",
                "ok": "1918",
                "er": "1914"
            }
        },
        "mven": {
            "payment": "1920",
            "webpay": {
                "method": "1923",
                "ok": "1931",
                "er": "1927"
            },
            "servipag": {
                "method": "1922",
                "ok": "1930",
                "er": "1926"
            }
        },
        "mvig": {
            "payment": "1921",
            "webpay": {
                "method": "1925",
                "ok": "1933",
                "er": "1929"
            },
            "servipag": {
                "method": "1924",
                "ok": "1932",
                "er": "1928"
            }
        },
    }
}
// console.log(interactions["vtr_com"]["billing"]); // shows when first time enters and choose vtr.com 1755
// console.log(interactions["vtr_com"]["pt"]["payment"]); // choose vtr.com and pay all 1748
// console.log(interactions["vtr_com"]["pt"]["webpay"]["method"]); // choose vtr.com, pay all and webpay 1750
// console.log(interactions["vtr_com"]["pt"]["webpay"]["ok"]); // choose vtr.com, pay all and webpay success 1754
// console.log(interactions["vtr_com"]["pt"]["webpay"]["er"]); // choose vtr.com, pay all and  webpay error 1752

// console.log(interactions["vtr_com"]["billing"]); // shows when first time enters and choose vtr.com 1755
// console.log(interactions["vtr_com"]["pt"]["payment"]); // choose vtr.com and pay all 1748
// console.log(interactions["vtr_com"]["pt"]["servipag"]["method"]); // choose vtr.com, pay all and servipag 1749
// console.log(interactions["vtr_com"]["pt"]["servipag"]["ok"]); // choose vtr.com, pay all and servipag success 1753
// console.log(interactions["vtr_com"]["pt"]["servipag"]["er"]); // choose vtr.com, pay all and  servipag error 1751


export default interactions;